import { render, staticRenderFns } from "./goodsProject.vue?vue&type=template&id=2e73d4ed&scoped=true&lang=html&"
import script from "./goodsProject.vue?vue&type=script&lang=js&"
export * from "./goodsProject.vue?vue&type=script&lang=js&"
import style0 from "./goodsProject.vue?vue&type=style&index=0&id=2e73d4ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e73d4ed",
  null
  
)

export default component.exports